import api from "../../index.js";
import { qs } from "../../../utils/utils.js";

export const GetWalletApi = (userId, params) => api.get(`wallet/get-walletdetailsbyrule/${userId}?${qs(params)}`);
export const GetWithdrawApi = () => api.get(`WalletMaster/Get-Withdraw-Type`);
export const GetWithdrawnewApi = (params) => api.get(`Withdraw/GetWithdraw-RequestByUserId?${qs(params)}`);
export const AddWithdrawRequestApi = (data) => api.post('wallet/add-withdraw-request', data);
export const GetAllWithdrawRequestApi = (userId, params) => api.get(`/wallet/getall-withdrawrequests-byuerid/${userId}?${qs(params)}`);
export const PaypalWithdrawApi = (data) => api.post('wallet/paypal-withdraw', data);
export const GetCredentialsApi = () => api.get(`UserMaster/credentials`);
export const DeletePendingRequest= (RequestID) => api.delete(`wallet/delete-withdraw-request/${RequestID}`);

